import * as React from 'react'
import dayjs from 'dayjs'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'

const today = dayjs()
const yesterday = dayjs().subtract(1, 'day')

export const DatePickerMUI = (props) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        defaultValue={yesterday}
        views={['year', 'month', 'day']}
        {...props}
      />
    </LocalizationProvider>
  )
}
